import { all, put, take } from 'redux-saga/effects';

import { SAVE_ANNOTATIONS } from './actions';
import { SAVE_HIGHLIGHTS, SAVE_NOTES } from 'reducers/dataModels';


function* saveAnnotations() {
  const { data:annotations } = yield take(SAVE_ANNOTATIONS);
  console.time('saveAnnotations#saveAnnotations')
  const [/* bookmarks,*/ highlightsAndNotes] = annotations;

  yield all([
    // put({ type: SAVE_BOOKMARKS, data: bookmarks }),
    put({ type: SAVE_HIGHLIGHTS, data: highlightsAndNotes[0] }),
    put({ type: SAVE_NOTES, data: highlightsAndNotes[1] })
  ]);
  console.timeEnd('saveAnnotations#saveAnnotations')
}


export default saveAnnotations;
